import { isMobile } from 'assets/core/js/common'

type OnOpenLinkListener = (card: HTMLElement) => void
interface Options {
  onOpenLink?: (card: HTMLElement) => void
}

const preventOpenClasses = [] as string[]

function openLink(url: string | null, card: HTMLElement, onOpenLink: OnOpenLinkListener | null): void {
  if (url) {
    if (!isMobile()) {
      window.open(url)
    } else {
      document.location.href = url
    }
    if (onOpenLink !== null) {
      onOpenLink(card)
    }
  }
}

function initializeOpenLink(card: HTMLElement, onOpenLink: OnOpenLinkListener | null): void {
  card.addEventListener('click', function (this: HTMLElement, e) {
    const target = e.target as HTMLElement
    if (preventOpenClasses.filter((val) => target.classList.contains(val) || target.closest(`.${val}`) !== null).length === 0) {
      e.preventDefault()
      e.stopPropagation()

      const link = card.querySelector<HTMLLinkElement>('.product-link')

      if (!link) {
        return
      }

      openLink(link.href, card, onOpenLink)
    }
  })
}

function initializeCommentToggle(card: HTMLElement): void {
  const button = card.querySelector<HTMLButtonElement>('.review-toggle')

  if (!button) {
    return
  }

  button.addEventListener('click', () => {
    const comment = button.closest('.review')

    if (comment !== null) {
      // decode the source comment the first time before making it visible.
      const sourceElement: HTMLElement | null = comment.querySelector<HTMLElement>('[data-comment-source]')

      if (sourceElement !== null) {
        const encodedComment = sourceElement.getAttribute('data-comment-source') as string
        const decodedComment = decodeURIComponent(atob(encodedComment))
        sourceElement.innerHTML = decodedComment
        sourceElement.removeAttribute('data-comment-source')
      }

      if (comment.hasAttribute('data-review-type')) {
        comment.removeAttribute('data-review-type')
      } else {
        comment.setAttribute('data-review-type', 'source')
      }
    }
  })
}

export default function (el: HTMLElement, options: Options = {}): void {
  if (el.hasAttribute('data-init')) {
    return
  }

  const product = el.querySelector<HTMLElement>('.product')

  if (!product) {
    return
  }

  initializeOpenLink(product, options.onOpenLink || null)
  initializeCommentToggle(el)

  el.setAttribute('data-init', 'true')
}
